import { defineMessages } from 'react-intl';

export default defineMessages({
    closeButtonAriaLabel: {
        id: 'view-popup-message.closeButtonAriaLabel',
        defaultMessage: 'Close',
    },
});
